import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Project } from '@src/app/models/project';
import { Projecttemplate } from '../model/projecttemplate';
import { Role } from '../model/role';

@Injectable({
  providedIn: 'root'
})
export class AssigntemplaterolesService {

  constructor(private http:HttpClient) { }

  getRoles(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Role[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+project.projectId+'/role/list',httpOptions)
  
  }
  assignTemplateRole(project:Project,roleId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var body = {assignedperson: personId};
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+project.projectId+'/role/'+roleId,JSON.stringify(body),httpOptions)
  
  }
}
